import { render } from "./UiPropJsonPathEditor.vue?vue&type=template&id=2b921388"
import script from "./UiPropJsonPathEditor.vue?vue&type=script&lang=js"
export * from "./UiPropJsonPathEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__